
export default {
    props: ['city','observer','isStuck'],
    data() {
        return {
            cards : [
                {
                    title: 'Présentation',
                    id: '#presentation'
                } ,
                {
                    title: 'Comparer',
                    id: '#compare'
                } ,
                (this.city.labels_count > 0) ?
                {
                    title: 'Labels',
                    id: '#labels'
                } : undefined,
                (this.city.region.id != 118) ?
                {
                    title: 'Population',
                    id: '#population'
                } : {},
                (this.city.region.id != 118 && this.city.weather_station) ?
                {
                    title: 'Climat',
                    id: '#climat'
                } : {} ,
                (this.city.region.id != 118) ?
                {
                    title: 'Économie',
                    id: '#economie'
                } : {}  ,
                (this.city.region.id != 118) ?
                {
                    title: 'Immobilier',
                    id: '#immobilier'
                } : {}  ,
                (this.city.region.id != 118) ?
                {
                    title: 'Sécurité',
                    id: '#securite'
                } : {}  ,
                {
                    title: 'Politique',
                    id: '#politique'
                } ,
                (this.city.region.id != 118) ?
                {
                    title: 'Services',
                    id: '#services'
                } : {}  ,
                {
                    title: 'Mairie',
                    id: '#cityhall'
                } ,
                {
                    title: 'Proximité',
                    id: '#near-by'
                } ,
                {
                    title: 'Avis',
                    id: '#reviews'
                } ,
            ].filter( Boolean ),
            scrollPosition: 0,
            links: '',
            currentIndex: 0,
            offset:0,
        }
    },
    computed: {
        cardSections() {
            return this.$parent.$refs.content.querySelectorAll('section');
        }
    },
    mounted() {
        this.links = document.querySelectorAll('#links li a');
        this.observer.observe(this.$el);
    },
    beforeMount() {
       window.addEventListener('scroll', this.handleScroll);
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        this.observer.disconnect();
    },
    methods: {
        handleScroll(event) {
            let index = this.cardSections.length;
            while (--index && (window.scrollY + 65)  < this.cardSections[index].offsetTop) {
            }
            this.currentIndex = index;
        },
    },
    watch: {
        currentIndex: function() {
            const linksContainer = document.getElementById('links');
            const activeLink = this.links[this.currentIndex];
            if (activeLink) {
                const left = activeLink.offsetLeft;
                const width = linksContainer.offsetWidth;
                const diff = left - (width/2);
                const scrollLeftValue = (linksContainer.offsetLeft + (diff+30));
                linksContainer.scroll({ top: 0, left: scrollLeftValue, behavior: 'smooth' });
            }
        },
    }
}
